import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "./theme";
import ChevronIcon from "./select-chevron.svg";

// TODO: Clear
// TODO: Label

export function Select({ value = null, options, onSelect, ...rest }) {
    const { altTextColor: fontColor, modularScale } = useTheme();
    const fontSize = modularScale(-1);

    const onChange = (e) =>
        onSelect?.(options.find(({ key }) => key === e.target.value));

    const selectedValue = value ? value.key : options[0];

    return (
        <>
            <select {...rest} value={selectedValue} onChange={onChange}>
                {options.map(({ key, label, disabled }) => (
                    <option key={key} value={key} disabled={disabled}>
                        {label}
                    </option>
                ))}
            </select>
            <style jsx>{`
                select {
                    font-size: ${fontSize}em;
                    color: ${fontColor};
                    padding: 0.75em 3em 0.75em 1em;
                    border: 2px solid #fff;
                    border-radius: 10px;
                    width: 15em;
                    appearance: none;
                    background-color: #fff;
                    background-image: url(${ChevronIcon});
                    background-position: right 1.25em center;
                    background-repeat: no-repeat;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                select:focus {
                    outline: 0;
                    border: 2px solid ${fontColor};
                }
            `}</style>
        </>
    );
}

export function ButtonSelect({ icon, className = "", ...rest }) {
    return (
        <span className={`button-select ${className}`}>
            <Select className="button-select__select" {...rest} />
            <style jsx>{`
                .button-select {
                    display: inline-block;
                }
                .button-select :global(.button-select__select) {
                    background-image: url(${icon});
                    background-position: left 1.5em center;
                    background-size: 1.5em;
                    background-repeat: no-repeat;
                    font-weight: 600;
                    padding: 1em 1.5em 1em 3.5em;
                    border-radius: 6em;
                    width: 11.25em; // 150px
                    cursor: pointer;
                }
            `}</style>
        </span>
    );
}

ButtonSelect.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string,
};
ButtonSelect.defaultProps = {
    className: "",
    icon: null,
};
